import {
    defineStore
} from 'pinia'

export const useMessageStore = defineStore('messageStore', {
    state: () => {
        return {
            message: {
                alert: null,
                success: null
            }
        }
    }
})